import { breakpoints } from './breakpoints';

export const isDesktopQuery = {
	query: `(min-width: ${breakpoints.desktop}px)`,
};

// query created to exclude ipad pro
export const isJustDesktopQuery = {
	query: `(min-width: ${breakpoints.desktop + 1}px)`,
};

export const isTabletQuery = {
	query: `(min-width: ${breakpoints.tablet}px) and (max-width: ${
		breakpoints.desktop - 1
	}px)`,
};

export const isTabletOrDesktopQuery = {
	query: `(min-width: ${breakpoints.tablet}px)`,
};

export const isTabletOrMobileQuery = {
	query: `(max-width: ${breakpoints.desktop - 1}px)`,
};

export const isMobileQuery = {
	query: `(max-width: ${breakpoints.phoneLg - 1}px)`,
};
